export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6383.f571f8e1.jpg";